<div (click)="select($event)"
  (dblclick)="toggleEditMode()"
  (mousedown)="rippleState='clicked'"
  (mouseup)="rippleState='none'"
  [class.disabled]="disabled"
  [attr.tabindex]="-1"
  [attr.aria-label]="getDisplayValue(model)">
  @switch (!!template) {
    @case (true) {
      <div [attr.contenteditable]="editing">
        <!-- CUSTOM TEMPLATE -->
        <ng-template
          [ngTemplateOutletContext]="{ item: model, index: index }"
          [ngTemplateOutlet]="template">
        </ng-template>
      </div>
    }
    @case (false) {
      <div class="tag-wrapper">
        <!-- TAG NAME -->
        <div [attr.contenteditable]="editing"
          [attr.title]="getDisplayValue(model)"
          class="tag__text inline"
          spellcheck="false"
          (keydown.enter)="disableEditMode($event)"
          (keydown.escape)="disableEditMode($event)"
          (click)="editing ? $event.stopPropagation() : undefined"
          (blur)="onBlurred($event)">
          {{ getDisplayValue(model) }}
        </div>
        <!-- 'X' BUTTON -->
        @if (isDeleteIconVisible()) {
          <delete-icon
            aria-label="Remove tag"
            role="button"
            (click)="remove($event)"
            >
          </delete-icon>
        }
      </div>
    }
  }
</div>

@if (isRippleVisible) {
  <tag-ripple [state]="rippleState"
    [attr.tabindex]="-1"
    >
  </tag-ripple>
}
